
import {BaseStoreItem} from '../../../../shared/store/BaseStoreItem'
import {ColonistMembershipProduct} from '../../../../shared/store/ColonistMembershipProduct'
import {UIStoreController} from './UIStoreController'
import {GiftedMembershipItem} from '../../../../shared/store/UserItems'
import {PaymentMethod} from '../../../../shared/store/BaseColonistStoreProduct'
import {ClientUserState} from '../ClientUserState'
import {UserState} from '../../../../shared/UserState'

export class UIStoreState {
    private readonly storeUI: UIStoreController

    constructor(storeUI: UIStoreController) {
        this.storeUI = storeUI
        setTimeout(() => {
            ClientUserState.registerChangeListener((userState) => {
                this.updateUserStoreState(userState)
            })
        }, 1)
    }

    set items(items: BaseStoreItem[]) {
        this.storeUI.bodyController.updateOwnedItems(items)
        this.storeUI.bodyController.updatePriceForFounderPack(items)
    }

    private _membershipToggleYearlyActive: boolean = true
    get membershipToggleYearlyActive(): boolean {
        return this._membershipToggleYearlyActive
    }
    set membershipToggleYearlyActive(yearlyActive: boolean) {
        this._membershipToggleYearlyActive = yearlyActive
        if(yearlyActive) {
            this.storeUI.bodyController.membershipItems.forEach((item) => {
                item.productDiv.style.display = item.membershipProduct.billedAnnually ? 'flex' : 'none'
            })
            this.storeUI.bodyController.membershipTabsController.setTabAnnual(true)
            return
        }
        this.storeUI.bodyController.membershipItems.forEach((item) => {
            item.productDiv.style.display = item.membershipProduct.billedAnnually ? 'none' : 'flex'
        })
        this.storeUI.bodyController.membershipTabsController.setTabAnnual(false)
    }

    setMembership(membership: ColonistMembershipProduct | undefined, paymentMethod: PaymentMethod | undefined) {
        this.storeUI.bodyController.updateOwnedMembership(membership, paymentMethod)
        this.storeUI.bodyController.updateSubscribedItems(membership, paymentMethod)

        const toggleYearlyActive = membership === undefined ? true : ColonistMembershipProduct.isAnnualMembership(membership.type)
        this.membershipToggleYearlyActive = toggleYearlyActive
    }

    set giftedMembershipItems(giftedMembershipItems: GiftedMembershipItem[]) {
        this.storeUI.bodyController.updateGiftedMemberships(giftedMembershipItems)
    }

    updateUserStoreState(userState: UserState | undefined) {
        this.items = userState?.items.getItems() ?? []
        const currentMembership = userState?.items.membership
        this.setMembership(currentMembership != undefined ? ColonistMembershipProduct.getMembershipProduct(currentMembership) : undefined, userState?.items.membershipPaymentMethod)
        this.giftedMembershipItems = userState?.items.giftedMemberships ?? []
    }
}
